// Preload images

function preloadImages() {
    preload([
        //pathImgFancybox + 'zoom.png'
    ]);
}
